<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2C0.895431 0 0 0.895431 0 2ZM14 3H2V5H14V3ZM14 7H2V9H14V7ZM2 11H9V13H2V11Z"
    fill="#3769D6"
  />
</template>
